import { render, staticRenderFns } from "./InfoMsgTitle.vue?vue&type=template&id=5eaa0207&"
import script from "./InfoMsgTitle.vue?vue&type=script&lang=js&"
export * from "./InfoMsgTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports